<template>
    <modal
        :active="active"
        @closed="$emit('closed', true)"
        :title="title()"
        :large="true"
    >
        <div class="tabs">
            <ul>
                <li v-for="tab in tabs" :key="tab.key" :class="{'is-active': activeTab === tab.key}" @click.prevent="activeTab = tab.key" >
                    <a>{{ tab.title }}</a>
                </li>
            </ul>
        </div>

        <template v-if="activeTab === 'descriptions'">
            <ItemDescriptions
                :form="form"
                @updated="localizationsUpdated"
            />
        </template>

        <template v-if="activeTab === 'terms'">
            <ItemTerms :form="form" @updated="update(false)" />
        </template>

        <template v-if="activeTab === 'compatibles'">
            <ItemCompatibles :form="form" @updated="update(false)" />
        </template>

        <template v-if="activeTab === 'masterData'">
            <div class="columns is-tablet">
                <form-field
                    class="column"
                    label="Type af vare"
                    inner-container-class="select is-fullwidth"
                >
                    <input-select
                        :options="listItemTypes"
                        v-model="form.type_id"
                        option-value-prop="id"
                        option-title-prop="name"
                        :error="error.type_id"
                        :disabled="item"
                        @input="onChangeItemType"
                    />
                </form-field>
                <form-field
                    class="column"
                    label="Kategori"
                    :error="error.item_subcategory_id"
                    inner-container-class="select is-fullwidth"
                >
                    <input-select
                        v-model="form.item_subcategory_id"
                        option-value-prop="id"
                        option-title-prop="name"
                        :error="error.item_subcategory_id"
                    >
                        <template v-slot:options>
                            <optgroup v-for="category in itemCategoryOptions" :key="category.id" :label="category.name">
                                <option v-for="subcategory in category.subcategoriesFlatten" :key="subcategory.id" :value="subcategory.id">
                                    {{ subcategory.name }}
                                </option>
                            </optgroup>
                        </template>
                    </input-select>
                </form-field>
               <div style="display: grid; grid-template-columns: 1fr 1fr">
                <form-field
                    class="column"
                    label="Sælges på webshop"
                    :error="error.sold_on_webshop"
                >
                    <b-switch
                        :rounded="false"
                        v-model="form.sold_on_webshop"
                        class="users-change__toggle"
                        :disabled="!isAdmin"
                    />
                </form-field>
                <form-field
                    class="column"
                    label="Kun visning?"
                    :error="error.only_show_on_webshop"
                >
                    <b-switch
                        :rounded="false"
                        v-model="form.only_show_on_webshop"
                        class="users-change__toggle"
                        :disabled="!isAdmin || !form.sold_on_webshop"
                    />
                </form-field>
               </div>
            </div>

            <div class="columns is-tablet">
                <form-field
                    class="column"
                    label="Model"
                    :error="error.model"
                >
                    <input-text
                        v-model="form.model"
                        :error="error.model"
                    />
                </form-field>

                <form-field
                    class="column"
                    label="Max. rabat"
                    :error="error.max_discount"
                    inner-container-class="select is-fullwidth"
                >
                    <input-select
                        :options="maxDiscountNumbers"
                        v-model="form.max_discount"
                        :error="error.max_discount"
                    />
                </form-field>

                <form-field
                    class="column"
                    label="Oprindelsesland"
                    :error="error.country_id"
                >
                    <InputSelectSearch
                        :options="listCountries"
                        v-model="countryId"
                        :error="error.country_id"
                        label="title"
                    />
                </form-field>
            </div>

            <div class="columns is-tablet">
                <form-field
                    class="column"
                    label="Fabrikant"
                    :error="error.manufacturer_id"
                    inner-container-class="select is-fullwidth"
                >
                    <InputSelect
                        :options="listManufacturers"
                        v-model="form.manufacturer_id"
                        :error="error.manufacturer_id"
                        option-value-prop="id"
                        option-title-prop="name"
                    />
                </form-field>
                <form-field
                    class="column"
                    label="Primær leverandør"
                    :error="error.primary_supplier_id"
                    inner-container-class="select is-fullwidth"
                >
                    <InputSelect
                        :options="listSuppliers"
                        v-model="form.primary_supplier_id"
                        :error="error.primary_supplier_id"
                        option-value-prop="id"
                        option-title-prop="name"
                    />
                </form-field>
                <form-field
                    class="column"
                    label="Sekundær leverandør"
                    :error="error.secondary_supplier_id"
                    inner-container-class="select is-fullwidth"
                >
                    <InputSelect
                        :options="listSuppliers"
                        v-model="form.secondary_supplier_id"
                        :error="error.secondary_supplier_id"
                        option-value-prop="id"
                        option-title-prop="name"
                    />
                </form-field>
            </div>

            <div class="columns is-tablet">
                <div class="column is-flex">
                    <form-field
                        label="Kostpris (DKK)"
                        class="w-full"
                        :error="error.cost_price"
                    >
                        <input-text
                            type="number"
                            v-model="costPrice"
                            :error="error.cost_price"
                            :class="{'is-outdated': item && item.cost_price.outdated}"
                        />

                    </form-field>
                    <div class="mt-8 mb-3 ml-1 is-flex">
                        <button
                            class="button ml-auto"
                            title="Historik"
                            @click.prevent="$emit('showHistory')"
                            :disabled="!item"
                        >
                            <span class="icon"><i class="fas fa-history"/></span>
                        </button>
                        <button
                            v-if="item && item.cost_price.outdated"
                            title="Bekræft kostpris"
                            class="button ml-1"
                            @click.prevent="$emit('confirmCostPrice')"
                        >
                            <span class="icon is-green"><i class="fas fa-check"/></span>
                        </button>
                    </div>

                </div>

                <form-field
                    class="column"
                    label="Min. antal"
                    :error="error.min_stock"
                >
                    <input-text
                        v-model="form.min_stock"
                        :error="error.min_stock"
                        :min="0"
                        v-if="isRealItem"
                        :max="100"
                        type="number"
                        :disabled="!isRealItem"
                    />
                    <em v-else>Skal ikke udfyldes</em>
                </form-field>

                <form-field
                    class="column"
                    label="Vægt (gram)"
                    :error="error.weight"
                >
                    <input-text
                        v-if="isRealItem"
                        v-model="form.weight"
                        :error="error.weight"
                        type="number"
                        :disabled="!isRealItem"
                    />
                    <em v-else>Skal ikke udfyldes</em>
                </form-field>
            </div>

            <div class="columns is-tablet">
                <form-field
                    class="column"
                    label="Længde (cm)"
                    :error="error.itemLength"
                >
                    <input-text
                        v-if="isRealItem"
                        v-model="form.itemLength"
                        :error="error.itemLength"
                        type="number"
                    />
                    <em v-else>Skal ikke udfyldes</em>
                </form-field>
                <form-field
                    class="column"
                    label="Bredde (cm)"
                    :error="error.width"
                >
                    <input-text
                        v-if="isRealItem"
                        v-model="form.width"
                        :error="error.width"
                        type="number"
                    />
                    <em v-else>Skal ikke udfyldes</em>
                </form-field>
                <form-field
                    class="column"
                    label="Højde (cm)"
                    :error="error.height"
                >
                    <input-text
                        v-if="isRealItem"
                        v-model="form.height"
                        :error="error.height"
                        type="number"
                    />
                    <em v-else>Skal ikke udfyldes</em>
                </form-field>
            </div>

            <div v-if="isAdmin" class="columns is-tablet">
                <form-field
                    class="column"
                    label="Toldkode"
                    :error="error.customs_code"
                >
                    <input-text
                        type="number"
                        v-model="form.customs_code"
                        :error="error.customs_code"
                    />
                </form-field>

                <form-field
                    class="column"
                    label="EAN"
                    :error="error.ean"
                >
                    <input-text
                        type="number"
                        v-model="form.ean"
                        :error="error.ean"
                    />
                </form-field>
            </div>

            <div class="columns mb-2">
                <form-field
                    class="column"
                    label="Noter"
                    :error="error.note"
                >
                    <InputTextarea v-model="form.note" rows="3"/>
                </form-field>
            </div>
        </template>

        <template v-if="selectedTab.showFooter" v-slot:footer>
            <div class="footer-spacer">
                <div>
                    <button class="button is-danger is-flex-left" @click="reset">Nulstil</button>
                    <button class="button is-default" @click="$emit('closed', true)">Annuller</button>
                    <button class="button is-primary" @click="submit">{{ saveButtonText }}</button>
                </div>

                <button class="button is-danger" @click="remove" v-if="isEdit">Slet</button>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'
import {FormField, InputText, InputCheckbox, InputSelect, InputDecimal, InputSelectSearch, InputTextarea } from '@elems/form'
import {mapGetters} from "vuex";
import ItemDescriptions from "@pages/items/forms/ItemDescriptions";
import ItemTerms from "@pages/items/forms/ItemTerms";
import ItemCompatibles from "@pages/items/forms/ItemCompatibles";

export default {
    components: {
        InputTextarea,
        InputSelectSearch,
        Modal,
        FormField,
        InputText,
        InputSelect,
        InputCheckbox,
        InputDecimal,
        ItemDescriptions,
        ItemTerms,
        ItemCompatibles
    },
    props: {
        active: Boolean,
        item: Object,
        viaList: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            form: {
                type_id: 1,
                item_subcategory_id: null,
                sold_on_webshop: false,
                only_show_on_webshop: false,
                model: '',
                customs_code: '',
                ean: '',
                weight: '',
                itemLength: '',
                width: '',
                height: '',
                min_stock: 0,
                max_discount: 0,
                note: '',
                country_id: null,
                manufacturer_id: null,
                primary_supplier_id: null,
                secondary_supplier_id: null,
                cost_price: 0,
                localizations: [],
                terms: [],
                compatibles: [],
            },
            costPrice: 0,
            maxDiscountNumbers: this.getMaxDiscountNumbers(),
            error: [],
            activeTab: 'masterData',
            tabs: [
                {
                    key: 'masterData',
                    title: 'Stamdata',
                    showFooter: true,
                },
                {
                    key: 'descriptions',
                    title: 'Beskrivelser',
                    showFooter: true,
                },
                {
                    key: 'terms',
                    title: 'Egenskaber',
                    showFooter: false,
                },
                {
                    key: 'compatibles',
                    title: 'Kompatibilitet',
                    showFooter: false,
                },
            ],
            itemCategories: [],
        }
    },
    computed: {
        ...mapGetters([
            'listCountries',
            'listManufacturers',
            'listSuppliers',
            'findCountry',
            'listItemTypes',
            'findItemType',
            'isAdmin',
            'listItemCategories',
        ]),
        selectedTab() {
            return this.tabs.find(x => x.key === this.activeTab);
        },
        itemCategoryOptions() {
            return this.listItemCategories.filter((category) => category.subcategoriesFlatten.length > 0);
        },
        countryId: {
            get() {
                return this.findCountry(this.form.country_id);
            },
            set(value) {
                this.form.country_id = value ? value.id : null
            }
        },
        isEdit() {
            return this.item !== null
        },
        saveButtonText() {
            return this.isEdit ? 'Gem' : 'Opret'
        },
        itemType() {
            return this.$store.getters.findItemType(this.form.type_id);
        },
        isRealItem() {
            const itemType = this.$store.getters.findItemType(parseInt(this.form.type_id));
            return itemType === undefined ? true : itemType.real_item;
        }
    },
    methods: {
        termsAdded(terms) {
            this.form.terms.push(...terms);
        },
        termRemoved(term) {
            this.form.terms = this.form.terms.filter(t => t.id !== term.id);
        },
        localizationsUpdated(localizations) {
            this.form.localizations = localizations;
        },
        onChangeItemType(typeId) {
            const itemType = this.findItemType(parseInt(typeId, 10));
            if (itemType.key === 'service') {
                this.form.weight = '';
                this.form.itemLength = '';
                this.form.width = '';
                this.form.height = '';
                this.form.max_discount = 0;
                this.form.min_stock = 0;
                this.form.customs_code = '';
                this.form.ean = '';
            }
        },
        title() {
            return this.isEdit
                ? 'Rediger vare'
                : 'Opret vare'
        },
        submit() {
            return this.isEdit ? this.update() : this.create()
        },
        getMaxDiscountNumbers() {
            const numbers = [];
            for (let i = 0; i <= 100; ++i) {
                numbers.push({
                    value: i,
                    title: `${i}%`
                });
            }
            return numbers;
        },
        create() {
            window.axios.post('/api/items', this.form)
                .then(({ data }) => {
                    this.$router.push({
                        name: 'items',
                        params: {
                            id: data.id,
                        },
                    });
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.error = error.response.data.errors
                    }
                });
        },
        update(closeModal = true) {
            if (!this.isEdit) return;

            window.axios.put('/api/items/' + this.item.id, this.form)
                .then(({ data }) => {
                    this.$store.dispatch('updateItem', data)
                    this.$emit('updated')

                    if (closeModal) {
                        this.$emit('closed')
                        this.$store.dispatch('setSuccess', 'Varen blev opdateret')
                        this.reset()
                    }
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.error = error.response.data.errors
                    }
                })
        },
        reset() {
            if (this.isEdit) {
                this.form = {
                    type_id: this.item.type_id,
                    item_subcategory_id: this.item.item_subcategory_id,
                    only_show_on_webshop: this.item.only_show_on_webshop,
                    sold_on_webshop: this.item.sold_on_webshop,
                    model: this.item.model,
                    customs_code: this.item.customs_code,
                    ean: this.item.ean,
                    weight: this.item.weight,
                    itemLength: this.item.itemLength,
                    width: this.item.width,
                    height: this.item.height,
                    min_stock: this.item.min_stock,
                    max_discount: this.item.max_discount,
                    note:  this.item.note_raw,
                    country_id: this.item.country_id,
                    manufacturer_id: this.item.manufacturer_id,
                    primary_supplier_id: this.item.primary_supplier_id,
                    secondary_supplier_id: this.item.secondary_supplier_id,
                    cost_price: this.item.cost_price?.price ?? 0,
                    localizations: this.item.localizations,
                    terms: this.item.terms,
                    compatibles: this.item.compatibles,
                }
                this.costPrice = this.form.cost_price / 100;
            } else {
                this.form = {
                    type_id: 1,
                    item_subcategory_id: null,
                    only_show_on_webshop: false,
                    sold_on_webshop: false,
                    model: '',
                    customs_code: '',
                    ean: '',
                    weight: '',
                    itemLength: '',
                    width: '',
                    height: '',
                    min_stock: 0,
                    max_discount: 0,
                    note: '',
                    country_id: null,
                    manufacturer_id: null,
                    primary_supplier_id: null,
                    secondary_supplier_id: null,
                    cost_price: 0,
                    localizations: [],
                    terms: [],
                    compatibles: [],
                }
                this.costPrice = 0;
            }
            this.error = []
        },
        remove() {
            if (!confirm('Er du sikker på du vil slette ' + this.form.model + '?')) {
                return
            }

            window.axios.delete('/api/items/' + this.item.id)
                .then(() => {
                    this.$emit('closed')
                    this.$emit('updated')
                    this.$store.dispatch('setSuccess', 'Varen blev slettet')
                    if (!this.viaList)
                        this.$router.push('/items')
                })
                .catch(error => {
                    this.$store.dispatch('setError', 'Varen kunne ikke slettes')
                })
        },
    },
    created() {
        this.$store.dispatch('loadSuppliers');
        this.$store.dispatch('loadManufacturer');
        this.$store.dispatch('loadCountries');
        this.$store.dispatch('loadItemTypes');
        this.$store.dispatch('loadLocales');
        this.$store.dispatch('loadItemCategories');

        if (this.item) {
            this.reset()
        }
    },
    watch: {
        form: {
            handler(newVal) {
                if (!newVal.sold_on_webshop) {
                    this.form.only_show_on_webshop = false;
                }
            },
            deep: true
        },
        item() {
            this.reset()
        },
        active() {
            if (!this.active) {
                this.activeTab = 'masterData';
            }
        },
        costPrice(value) {
            this.form.cost_price = value * 100;
        }
    },
}
</script>

<style lang="scss" scoped>
.footer-spacer {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
}

.customer-details {
    h4 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #bbb;
        margin-bottom: 25px;
        cursor: pointer;

        i {
            transition: transform .3s ease-in-out;
        }
    }

    .column {
        display: none;
    }

    &.open {
        h4 i {
            transform: rotate(.5turn);
        }

        .column {
            display: block;
        }
    }


}

.column {
    padding: 0 0.75rem;
}
.is-outdated {
    color: red;
    font-weight: bold;
}
</style>
